// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1m4ug","header":"ReportDetails_header__XrZD6","title":"ReportDetails_title__3933z","left":"ReportDetails_left__2emZl"};